import { StatusScreenTypeEnum } from '@qvs/core';

export const statusScreenIconUrlMap = new Map<StatusScreenTypeEnum, string>([
  [StatusScreenTypeEnum.SUCCESS, 'assets/images/common_success_icon.svg'],
  [StatusScreenTypeEnum.PENDING, 'assets/images/common_loading_icon_blue.svg'],
  [StatusScreenTypeEnum.APP_SWITCH, 'assets/images/common_app_switch_icon.svg'],
  [StatusScreenTypeEnum.WARNING, 'assets/images/common_warning_icon.svg'],
  [StatusScreenTypeEnum.FAILED, 'assets/images/common_error_icon.svg']
]);
